import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const ArticleCollectionDescription = styled.p(
    ({ theme: { fontSizes, spacing } }) => css`
        max-width: 720px;
        font-size: ${fontSizes[9]};
        font-weight: 400;
        line-height: 1.625;
        color: #322744;
        padding: ${spacing['8px']} 0 ${spacing['24px']};
    `
);
